import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { Box, Modal, Stack, Card, CardContent, CardHeader, Button, ToggleButton, ToggleButtonGroup, Alert } from '@mui/material';
import { updateOrderAction } from '../../../../services/request';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ChangeStateModal = ({ order, open, handleClose, setOrders = null }) => {
  const [state, setState] = React.useState(order.state);
  const { mutate, error } = useMutation(updateOrderAction);
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleChange = (event, newState) => {
    if (newState !== null) {
      setState(newState);
    }
  };

  const handleSubmit = async () => {
    const { error: mutateError, payload } = await mutate(order.id, { state });
    if (!mutateError) {
      if (setOrders !== null) {
        setOrders(prev => prev.map(o => o.id === order.id ? payload : o));
      }
      handleClose();
    } else if (_.isArray(payload)) {
      setErrorMessage(payload[0]);
    } else {
      setErrorMessage('Nie udało się zmienić statusu');
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} >
        <Card sx={{ ...style, width: '350px' }}>
          <CardHeader
            title={`Zmień status zamówienia ${order.identifier}`}
            sx={{ textAlign: 'center' }}
          />
          <CardContent sx={{ textAlign: 'center' }}>
            <ToggleButtonGroup
              color="primary"
              orientation="vertical"
              value={state}
              exclusive
              onChange={handleChange}
            >
              <ToggleButton value="RES">Zgłoszony</ToggleButton>
              <ToggleButton value="ACC">Zaakceptowany</ToggleButton>
              <ToggleButton value="ACT">Aktywny</ToggleButton>
              <ToggleButton value="GIN">Rezygnacja</ToggleButton>
            </ToggleButtonGroup>
            { error
              ? <>
                <Box height={40}/>
                <Alert variant="outlined" severity="error">{errorMessage}</Alert>
              </>
              : null}
            <Box height={40} />
            <Stack direction="row" justifyContent="space-around" alignItems="end" flexGrow={1}>
              <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Anuluj</Button>
              <Button sx={{ flexGrow: 0.4 }} disabled={order.state === state} variant="contained" onClick={handleSubmit}>Zmień status</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </>
  );
};


export default ChangeStateModal;
